import './TableHeaderColumn.scss';

function TableHeaderColumn({ item }) {
  return (
    <div
      className={`table-header-column ${item.key} ${
        item?.grow === false ? 'dont-grow' : ''
      }`}
    >
      {item.name}
    </div>
  );
}

export default TableHeaderColumn;
